import React from "react";
import "./Vission_mission.css";

function Vission_mission() {
  return (
    <>
      <section className="Vission_mission">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-4 col-sm-6 col-10">
              <div className="main_img_holder">
                <img
                  className="main_section_img"
                  src="/assets/images/about_us/visson_Mission/main_img.png"
                  alt=""
                />
              </div>
            </div>

            <div className="col-md-8">
              <div className="row h-100">
                <div className="col-md-6">
                  <div className="card_holder">
                    <div>
                      <div className="heading_holder">
                        <div>
                          <div className="img_holder">
                            <img
                              className="card_v_m_img"
                              src="/assets/images/about_us/visson_Mission/vision.png"
                              alt=""
                            />
                          </div>
                        </div>
                        <h5>Vission</h5>
                      </div>

                      <div className="text_holder">
                        <p>
                          To be a trusted partner in career advancement,
                          enabling lifelong earning and growth through
                          innovative education and strong industry connections.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="card_holder">
                    <div>
                    <div className="heading_holder">
                      <div>
                        <div className="img_holder">
                          <img
                            className="card_v_m_img"
                            src="/assets/images/about_us/visson_Mission/mission.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <h5>Mission</h5>
                    </div>

                    <div className="text_holder">
                      <p>
                        To be a trusted partner in career advancement, enabling
                        lifelong earning and growth through innovative education
                        and strong industry connections.
                      </p>
                    </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Vission_mission;
